import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import emitter from 'tiny-emitter/instance'
const { url } = window.__VUE_WORDPRESS__.routing

// scroll position is handled in @after-leave transition hook
// if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Add navigation guard to handle project URLs
router.beforeEach((to, from, next) => {
  // Check if Vue is disabled (for project pages)
  if (window.__VUE_DISABLED__) {
    // Let WordPress handle the page
    window.location.href = to.fullPath;
    return;
  }
  
  // Check if the route is for a project
  if (to.path.startsWith('/project/')) {
    // Redirect to WordPress to handle project pages
    window.location.href = to.fullPath;
    return;
  }
  
  // Check if we're on a project archive page
  if (to.path === '/projects/' || to.path === '/projects') {
    // Redirect to WordPress to handle project archive
    window.location.href = to.fullPath;
    return;
  }
  
  // Not a project URL, proceed normally
  next();
})

export { router }
